export const PaymentsQueryKeys = {
  CREATE_BANK_ACCOUNT_LINK: ['create-bank-account-link'],
  CREATE_AEROPAY_DEPOSIT: ['create-aeropay-deposit'],
  AEROPAY_CHALLENGE_REQUIRED: (userId: string) => ['aeropay-challenge-required', userId],
  AEROPAY_CONFIRM_USER: (userId: string) => ['aeropay-confirm-user', userId],
  GET_AEROPAY_LINKED_BANK_ACCOUNTS: (userId: string) => ['aeropay-linked-bank-accounts', userId],
  CRYPTO_DEPOSIT_ADDRESSES: (userId?: string) => ['crypto-deposit-addresses', userId],
  CRYPTO_DEPOSIT_ARRIVALS: (userId?: string) => ['crypto-deposit-arrivals', userId],
  CREATE_CRYPTO_DEPOSIT_ADDRESSES: ['create-crypto-deposit-addresses'],
};
